import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import _ from 'underscore';

const initialState = {
  key: '',
  privileges: null,
};

const DetailNavigation = ({ id }) => {
  const History = useHistory();
  const location = useLocation();
  const Session = useSelector((state) => state.Auth?.session);

  const [{ key, privileges }, setState] = React.useState(initialState);
  const { pathname } = location;

  const $getPriviledge = async () => {
    const payload = {};

    const location = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location',
    });

    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    const user = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.user',
    });

    if (location) {
      payload.location = true;
    }

    if (pricing) {
      payload.pricing = true;
    }

    if (user) {
      payload.user = true;
    }

    setState((prevState) => ({ ...prevState, privileges: payload }));
  };

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, key: pathname }));
  }, [location]);

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  return (
    <div className="d-flex flex-column border-bottom mb-1 mb-md-0 h-100 border-end">
      <div>
        <Nav
          activeKey={key}
          onSelect={(k) => {
            setState((prevState) => ({ ...prevState, key: k }));
            History.push(k);
          }}
          className="d-flex flex-row flex-md-column"
        >
          <Nav.Link
            eventKey={`/master/customer/${id}`}
            className="nav-link-tabs-dark fw-medium p-3 w-100 border-bottom"
          >
            <span className="nav-link-title fw-medium" style={{ fontSize: 13 }}>
              Detil
            </span>
          </Nav.Link>
          {!Session?.privileges || privileges?.location ? (
            <Nav.Link
              eventKey={`/master/customer/${id}/location`}
              className="nav-link-tabs-dark fw-medium p-3 w-100 border-bottom"
            >
              <span
                className="nav-link-title fw-medium"
                style={{ fontSize: 13 }}
              >
                Daftar Alamat
              </span>
            </Nav.Link>
          ) : null}
          {!Session?.privileges || privileges?.pricing ? (
            <Nav.Link
              eventKey={`/master/customer/${id}/pricing`}
              className="nav-link-tabs-dark fw-medium p-3 w-100 border-bottom"
            >
              <span
                className="nav-link-title fw-medium"
                style={{ fontSize: 13 }}
              >
                Daftar Harga
              </span>
            </Nav.Link>
          ) : null}
          {!Session?.privileges || privileges?.user ? (
            <Nav.Link
              eventKey={`/master/customer/${id}/user`}
              className="nav-link-tabs-dark fw-medium p-3 w-100 "
            >
              <span
                className="nav-link-title fw-medium"
                style={{ fontSize: 13 }}
              >
                Daftar User
              </span>
            </Nav.Link>
          ) : null}
        </Nav>
      </div>
    </div>
  );
};

export default DetailNavigation;
